import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface EssayAuxiliarState {
  selected: number | null;
  paperHeight: number;
  setSelected: (selected: number | null) => void;
  setPaperHeight: (height: number) => void;
}

export const useEssayAuxiliarStore = create<EssayAuxiliarState>()(
  persist(
    (set) => ({
      selected: null,
      paperHeight: 900,
      setSelected: (selected: number | null) => set({ selected }),
      setPaperHeight: (height: number) => ({ paperHeight: height })
    }),
    { name: 'essays-auxliar' }
  )
);